import { useMemo } from "react";
import PropTypes from "prop-types";

import { alignItems, strCode } from "../../../../../consts";
import { t } from "../../../../../services";
import { dateUtil } from "../../../../../utils";
import { adminRolesConfigUtils } from "../../utils/adminRolesConfigUtils";

import { FlexContainers, IconButton, SVG, WrapperContainer } from "../../../../../components";
import { RoleCardWrapper, RoleDateInfo, Subtitle, Title } from "../RolesList/styled";

export const AdminRoleCard = ({ roleConfig, onEditConfig = () => {} }) => {
  const roleNames = useMemo(() => {
    return roleConfig?.roles?.map((role) => role?.value)?.join(", ") ?? null;
  }, [roleConfig]);

  const appNames = useMemo(() => {
    return roleConfig?.applications?.map((role) => role?.value)?.join(", ") ?? null;
  }, [roleConfig]);

  const validUntil = useMemo(() => {
    return adminRolesConfigUtils.formatDate(roleConfig?.activeTo) ?? null;
  }, [roleConfig]);

  const isExipred = useMemo(() => {
    if (roleConfig?.activeTo) {
      const dateDiff = dateUtil.getDateDifferenceInMilliseconds(new Date(), roleConfig?.activeTo);

      return dateDiff > 0;
    }

    return false;
  }, [roleConfig]);

  return (
    <RoleCardWrapper
      Container={FlexContainers.FlexColumn}
      alignItems={alignItems.start}
      width={"100%"}
      gap={16}>
      <WrapperContainer
        Container={FlexContainers.FlexRowBetween}
        alignItems={alignItems.start}
        width={"100%"}
        gap={16}>
        <WrapperContainer Container={FlexContainers.FlexColumnStart} alignItems={alignItems.start}>
          <Title>{roleNames}</Title>

          {appNames ? <Subtitle>{appNames}</Subtitle> : null}
        </WrapperContainer>

        <WrapperContainer
          Container={FlexContainers.FlexColumnStart}
          alignItems={alignItems.end}
          minWidth={"fit-content"}
          gap={8}>
          <IconButton onClick={() => onEditConfig(roleConfig)}>
            <SVG.EditIcon />
          </IconButton>

          {validUntil && (
            <RoleDateInfo isExipred={isExipred}>
              {isExipred
                ? t(strCode.EXPIRED_INFO, { validUntil })
                : t(strCode.VALID_UNTIL_INFO, { validUntil })}
            </RoleDateInfo>
          )}
        </WrapperContainer>
      </WrapperContainer>
    </RoleCardWrapper>
  );
};

AdminRoleCard.propTypes = {
  roleConfig: PropTypes.shape({
    accessType: PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }).isRequired,
    applications: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
    ).isRequired,
    markets: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
    ),
    location: PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }),
    roles: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
    ).isRequired,
    activeFrom: PropTypes.instanceOf(Date).isRequired,
    activeTo: PropTypes.instanceOf(Date).isRequired
  }).isRequired,
  onEditConfig: PropTypes.func.isRequired
};
